import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import DispData from './DispData';
import * as commonLogic from '../../logic/CommonLogic';
import * as dispTypes from '../../constants/common/ConstDispTypes';
import mainReducer from '../../reducers/K007/Reducer';
import * as defaultValue from '../../constants/common/ConstDefaultValue';
import * as authenticator from '../../logic/Authenticator';
import * as cookies from '../../logic/Cookies';

const initialState = {
  kubun: commonLogic.getKubunFromURL(),  // 区分
  term: commonLogic.getTermFromURL(),  // 期間
  termData: null,
  termStart: null,            // 集計開始日
  termEnd: null,            // 集計終了日
  nohinTermData: null,
  dispFlg: dispTypes.DAYOFF_TYPEOFF,
  rate: commonLogic.getRateFromURL(),
  nohinkaishibi: commonLogic.getNohinURL(),
  nohinkaishibiFrom: commonLogic.getNohinFromURL(),
  nohinkaishibiTo: commonLogic.getNohinToURL(),
  isFromDatePicker: false, // 納品時期のFromカレンダーかどうか
  type: commonLogic.getTypeFromURL(),
  maker: defaultValue.DEFAULT_MAKER,
  kishu: commonLogic.getKishuNameFromURL(),
  pskubun: commonLogic.getPSKubun(),
  dayFlg: commonLogic.getdayFlgFromURL(),
  dataDayOn: null, // 平日・休日表示ONデータ 明細行
  dataDayOff: null, // 平日・休日表示OFFデータ 明細行
  dataAllDayOn: null, // 平日・休日表示ONデータ 固定行
  dataAllDayOff: null, // 平日・休日表示OFFデータ 固定行
  error: null,
  msgID: 'M0004',  // now loading
  remainderAPICount: 1,  // API処理 残件数
  callApiPlanTime: null,  // API呼び出し予定時間(null=無制限)
  dataPachiFound: false,
  dataPachi: null,
  dataPachiDayOn: null,
  dataSlotFound: false,
  dataSlot: null,
  dataSlotDayOn: null,
  itemList: commonLogic.createItemList(),
  offset: defaultValue.DEFAULT_OFFSET,
  scrollTop: 0,
  dataCnt: 0, // グリッドデータの総数
  errArray: null, // APIパラメータエラーのパラメータ名配列
  controlErrFlg: false,
  scrollEnd: false,
  focusFlg: false,
  userName: '',
  isPc: isPc(), // Pc or Tablet
  calledWebFontAPI: false, // WebFontAPIが呼ばれたかどうか
  isOpenCalendar: false, // 期間カレンダーまたは納品開始日ダイアログが開かれているかどうか
  calendarViewMode: defaultValue.DEFAULT_CALENDAR_VIEW_MODE,
  kikanUnit: commonLogic.getKikanUnitFromURL(),
  displayDate: null,
  isNohinCalendar: false,
  gouki: defaultValue.DEFAULT_GOUKI,
  smartYugiki: defaultValue.DEFAULT_SMARTYUGIKI,
  yugitype: defaultValue.DEFAULT_YUGI_TYPE,
  sortKey: 'out',
  sortOrder: 'desc',
  sortDay: 'everyday',

  isViewReload: true,
  kubunIds: [],
  typeIds: [],
  makerIds: [],
  goukiIds: [],
  smartYugikiIds: [],
  yugitypeIds: [],

  usedMachinePriceDataUpdateFlag: 0


};

// 認証
authenticator.Authentication();

// 前回検索条件の復元
const flg = sessionStorage.getItem('recoverLastSearch');
const condition = JSON.parse(sessionStorage.getItem('condition'));
const gmnID = sessionStorage.getItem('gmnID');
if (flg && condition && gmnID === 'K007') {
  sessionStorage.removeItem('recoverLastSearch');
  sessionStorage.removeItem('condition');
  sessionStorage.removeItem('gmnID');
  if (condition.kubun) initialState.kubun = condition.kubun;
  if (condition.term) initialState.term = condition.term;
  if (condition.dayFlg) initialState.dayFlg = condition.dayFlg;
  if (condition.pskubun) initialState.pskubun = condition.pskubun;
  if (condition.rate) initialState.rate = condition.rate;
  if (condition.nohinkaishibi) initialState.nohinkaishibi = condition.nohinkaishibi;
  if (condition.type) initialState.type = condition.type;
  if (condition.maker) initialState.maker = condition.maker;
  if (condition.yugitype) initialState.yugitype = condition.yugitype;
  if (condition.kishu) initialState.kishu = condition.kishu;
  if (condition.gouki) initialState.gouki = condition.gouki;
  if (condition.smartYugiki) initialState.smartYugiki = condition.smartYugiki;
  if (condition.sortKey) initialState.sortKey = condition.sortKey;
  if (condition.sortOrder) initialState.sortOrder = condition.sortOrder;
  if (condition.sortDay) initialState.sortDay = condition.sortDay;
} else {
  // 横スクロールポジションの初期位置をcookieにセット
  cookies.setItem('scrollPosition', -1);

  sessionStorage.setItem('reAuthenticationCnt', 0);
  sessionStorage.setItem('reAuthenticationCntOpenId', 0);
}

sessionStorage.removeItem('nowTransition');

const enhancer = applyMiddleware(thunkMiddleware);
const store = createStore(mainReducer, initialState, enhancer);

render(
  <Provider store={store}>
    <DispData />
  </Provider>,
  document.getElementById('disp_data')
);
